import axios from 'axios'
import router from './router'
import store from './store'

axios.defaults.baseURL = process.env.API_URL

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('etend.token')
    if (token !== null) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      store.commit('log_out')
      router.push({path: '/'})
    }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/api.js